import { createContext, useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import { Brief, sampleBrief } from "@/components/offsite-demo/data";

type Ctx = {
  brief: Brief;
  setBrief: (b: Brief) => void;
  reset: () => void;
};

const OffsiteContext = createContext<Ctx | null>(null);

export function useOffsite(): Ctx {
  const ctx = useContext(OffsiteContext);
  // Fallback keeps deep links working if the provider is ever bypassed.
  if (!ctx) return { brief: sampleBrief, setBrief: () => {}, reset: () => {} };
  return ctx;
}

export default function OffsiteLayout() {
  const [brief, setBrief] = useState<Brief>(sampleBrief);
  return (
    <OffsiteContext.Provider
      value={{ brief, setBrief, reset: () => setBrief(sampleBrief) }}
    >
      <Outlet />
    </OffsiteContext.Provider>
  );
}
